import { useSelector } from "react-redux";
import { useRole } from "./use-role";

export const useAuth = (code) => {
    const role = useRole();
    const permission = useSelector(state => state.Auth.permission);

    return role === 1 || permission && permission[code] > 0;
};

export const useAuthReadOnly = (code) => {
    const role = useRole();
    const permission = useSelector(state => state.Auth.permission);

    return role === 1 || permission && permission[code] > 0;
};

export const useAuthEditable = (code) => {
    const role = useRole();
    const permission = useSelector(state => state.Auth.permission);

    return role === 1 || permission && permission[code] > 1;
};

export const useAuthFullAccess = (code) => {
    const role = useRole();
    const permission = useSelector(state => state.Auth.permission);

    return role === 1 || permission && permission[code] > 2;
};